export default function ({ store }) {
  const isMap = window.isMap
  store.dispatch('setIsMap', isMap)
}
